module.exports = __webpack_public_path__ + "img/apple.350fe581.svg";